export class LoginStatusModel {
	is_anonymous: boolean;
	uid: number;
	email: string;
	is_masquerading: boolean;
	logout_token?: string;
}
